<template>
	<div>
		<p class="desc-info">
			<span>订单号：{{ flowInfo.orderId }}</span>
			<span>任务类型：质控</span>
			<span>当前任务状态：{{ this.$flowStatus.get(flowInfo.status) }}</span>
			<span v-if="qcName.length > 0">质控人：{{ qcName }}</span>
			<span>语种方向：{{ $sysLan.get(slan) }}-{{ $sysLan.get(tlan) }}</span>
		</p>
		<el-tabs type="card" v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="质控配置" name="1">
				<zkConfigure3 v-if="flowInfo.orderId" :wordNum="flowInfo.wordNum" ref="zkConfigure3"/>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import zkConfigure3 from '../dot/order/taskTemplate/qc-configure-status3'
import zkStatistics from '../dot/order/taskTemplate/qc-statistics'
import {getFlowInfo, finish} from '@/api/dot/qc'
import {getObj} from '@/api/dot/order'
import fileDown from '@/views/common/fileDown'
import {mapGetters} from "vuex";
import {alertErroMsg, alertSuccessMsg} from "@/util/commonMsg";
import {getByStaffId} from "@/api/admin/user";

export default {
  	components: {zkConfigure3, zkStatistics, fileDown},
	data() {
		return {
			tranFromat:'1',
			activeName: "1",
			flowInfo: {},
			configInfo: {},
			page: false,
			slan: "",
			tlan: "",
			qcData: [],
			qcName: "",
		}
	},

	computed: {
		...mapGetters(['permissions']),
	},
	created: function () {
		this.flowInfo = {}
		this.configInfo = {}
		getFlowInfo(this.$route.params.id).then(response => {
			this.flowInfo = response.data.data;
			getObj(this.flowInfo.orderId).then(res => {
				this.slan = res.data.data.slan;
				this.tlan = res.data.data.tlan;
			})
			let tempConfig = this.flowInfo;
			if(this.flowInfo.qcConfigDto) {
				tempConfig = this.flowInfo.qcConfigDto;
			}
			if(this.flowInfo.orderId) {
				tempConfig.orderId = this.flowInfo.orderId;
			}
			tempConfig.limitTime = this.flowInfo.limitTime;
			tempConfig.wordsCount = this.flowInfo.wordsCount;
			tempConfig.qcList = this.flowInfo.userWebVos;
			tempConfig.status = this.flowInfo.status;
			tempConfig.peEndTime = this.flowInfo.peEndTime;
			tempConfig.isConfigDisabled = this.flowInfo.status !== 1;
			tempConfig.isQcCanChoose = this.flowInfo.status === 1 || this.flowInfo.status === 2;
			this.configInfo = tempConfig;
			this.qcName = "";
			if(this.flowInfo.operatorId != null) {
				getByStaffId(this.flowInfo.operatorId).then(response => {
					this.qcName = response.data.data.realname;
				})
			}
		})
	},

	mounted() {
	},

	methods: {
		handleClick(tab, event) {
			if (tab.name === "2") {
				this.$refs.zkStatistics.init();
			} else if (tab.name === "3") {
				this.$refs.qcDown.init();
				this.$refs.qcTranDown.init();
				this.$refs.qcExcelDown.init();
			} else if (tab.name === "5") {
				this.$refs.qcExcelDown.init();
			}
		},

		endMission() {
			let msg = "";
			//待领取
			if (this.flowInfo.status === 2) {
				msg = "质控任务还未开始，此时结束任务，可能造成风险，确定结束？"
			} else if (this.flowInfo.status === 3) {
				msg = "质控任务还在进行中，此时结束任务，可能造成项目风险，确定结束任务？<br> PS:质控成本仍按照质控领取任务金额结算"
			} else {
				msg = "确定结束任务？"
			}
			this.$alert(msg, {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				showCancelButton: true,
				dangerouslyUseHTMLString: true,
				callback: action => {
					if (action === 'confirm') {
						//结束QC
						this.finishQc()
					} else {
						this.$router.replace('/refresh')
					}
				},
			});
		},

		finishQc() {
			finish(this.$route.params.id).then(res => {
				if (res.data.data === 1) {
					alertSuccessMsg()
				} else if (res.data.data === -4) {
					alertErroMsg("PE任务还在进行中，不能结束质控任务")
				} else {
					alertErroMsg()
				}
			})
		},
	},

	filters: {},
}

</script>
<style lang="scss" scoped>
.avue-view {
  background: #FFFFFF;
  padding: 20px;
  min-height: calc(100vh - 100px);
}

.desc-info {
  width: 100%;
  padding-left: 0;

  > span {
    margin-right: 50px;
  }
}

</style>
